function toTitleCase(str)
{
    return str.replace(/(?:^|\s)\w/g, function(match) {
        return match.toUpperCase();
    });
}

Property_region_search = {
	init : function(){
		
		// Check if region search elements are on page.
		if( jQuery( 'input[name="region_search"]' ).size() == 0 )
		{
			return false;
		}
		
		// Get data.
		var options = new Object();
		options.abn = sh__site_object.property_options.client.abn;//'FRA3CA475B3F49149C78C41C76FFFE63';
		options.license_1 = sh__site_object.property_options.client.sh_licence_1;//'F4D2078B0648442C99A90918B6B5612F';
		options.property_type = 'holiday';
		
		//var region_data = Property_region_search.get_region_data(options);
		Property_region_search.get_region_data(options);
		
		// Select previous entry for usability.
		jQuery('input[name="region_search"]').on('click', function() {
			jQuery(this).select();
		});
		
		// Set input to loading.
		jQuery('input[name="region_search"]').attr('readonly','readonly').addClass('loading');
	}
	,
	translate_region_data : function( pm_options )
	{
		var region_data = pm_options.data;
		
		var regions = region_data.regions;
		
		var regions_array = [];
		
		for(region_index in regions)
		{
			var region = regions[region_index];
			//console.log('REGION: ', region);
			//regions_array
			//availableTags.push({value:region.id,label:region.name});
			var region_name = region.name;
			var region_id = region.id;
			//region_name = region_name.toLowerCase();
			regions_array.push( {region_id: region_id, suburb: '', label: region_name} );
			
			for(suburb_index in region.suburbs)
			{
				var suburb = region.suburbs[suburb_index];
				suburb = suburb.toLowerCase();
				suburb = toTitleCase(suburb);
				regions_array.push( {region_id: '', suburb: suburb, label: suburb + ' - ' + region.name} );
			}
		}
		
		return( regions_array );
	}
	,
	get_region_data : function( pm_options )
	{
		var post_data = new Object();
		post_data.ABN = pm_options.abn;
		post_data.license1 = pm_options.license_1;
		post_data.propertyType = pm_options.property_type;
		
		jQuery.ajax({
			url: "https://svc.sherlock.com.au/PropertyService/Service.php/getRegions",
			type: "POST",
			data: JSON.stringify(post_data),
			contentType: "text/plain; charset=utf-8",
			dataType: "json",
			success: function (result) {
				if(result.isSuccess){
					
					var options = new Object();
					options.data = result;
					var region_data = Property_region_search.translate_region_data(options);
					
					jQuery( 'input[name="region_search"]' ).autocomplete({
						source: region_data,
						focus: function( event, ui ) {
							//jQuery(this).val( ui.item.label );
							//jQuery(this).siblings('input[name="region_id"]').val( ui.item.region_id );
							//jQuery(this).siblings('input[name="region_suburb"]').val( ui.item.suburb );
							//jQuery(this).siblings('input[name="suburb"]').val( ui.item.suburb );
							return false;
						},
						select: function( event, ui ) {
							jQuery(this).val( ui.item.label );
							jQuery(this).siblings('input[name="region_id"]').val( ui.item.region_id );
							jQuery(this).siblings('input[name="region_suburb"]').val( ui.item.suburb );
							jQuery(this).siblings('input[name="suburb"]').val( ui.item.suburb );
							return false;
						},
					});
					
					// Insure autocomplete attribute is something random as Chrome no longer respects 'off'.
					jQuery('input[name="region_search"]').attr('autocomplete','region-search');
					
					// Set input to not loading.
					jQuery('input[name="region_search"]').removeAttr('readonly').removeClass('loading');
				}
			}
		});
	}
}

jQuery(document).ready(function(jQuery){
	
	/*
		sh__site_object = global object loaded via WordPress.
	*/
	
	var test_data = [
	    {
	        id: 0,
	        text: 'enhancement'
	    },
	    {
	        id: 1,
	        text: 'bug'
	    },
	    {
	        id: 2,
	        text: 'duplicate'
	    },
	    {
	        id: 3,
	        text: 'invalid'
	    },
	    {
	        id: 4,
	        text: 'wontfix'
	    }
	];
	
	//jQuery('[name="region_search"]').select2({
	//	data: test_data,
	//});
	
	// Check if region search elements are on page.
	if( jQuery( 'select[name="region_search"]' ).size() > 0 )
	{
		var post_data = new Object();
		post_data.ABN = sh__site_object.property_options.client.abn;//'FRA3CA475B3F49149C78C41C76FFFE63';
		post_data.license1 = sh__site_object.property_options.client.sh_licence_1;//'F4D2078B0648442C99A90918B6B5612F';
		post_data.propertyType = 'holiday';
		
					
		jQuery.ajax({
			url: "https://svc.sherlock.com.au/PropertyService/Service.php/getRegions",
			type: "POST",
			data: JSON.stringify(post_data),
			contentType: "text/plain; charset=utf-8",
			dataType: "json",
			success: function (result) {
									
				if(result.isSuccess)
				{
					var regions = result.regions;				
					var regions_array = [];
					var option_index = 1;
				
					for(region_index in regions)
					{
						var region = regions[region_index];
						var region_name = region.name;
						var region_id = region.id;
			
						regions_array.push( { id: option_index, text: region_name, suburb: '', region_id: region_id } );
						option_index++;
							
						region.suburbs.sort();
							
						for(suburb_index in region.suburbs)
						{
							var suburb = region.suburbs[suburb_index];
							suburb = suburb.toLowerCase();
							suburb = toTitleCase(suburb);
							var label = suburb + ' - ' + region.name;
						
							//regions_array.push( {id: parseInt(suburb_index), text: suburb} );
							regions_array.push( { id: option_index, text: label, region_id: '', suburb: suburb } );
							//{region_id: , label: region_name}
							// regions_array.push( {region_id: '', suburb: suburb, label: suburb + ' - ' + region.name} );
							option_index++;
						}
					}
						
					jQuery('select[name="region_search"]').select2({
						data: regions_array,
						theme: 'bootstrap4',
						width: '100%',
					});
				
					jQuery('select[name="region_search"]').on('select2:select', function (e) {
						var data = e.params.data;
						console.log(data);
					
						jQuery(this).siblings('input[name="region_id"]').val( data.region_id );
						jQuery(this).siblings('input[name="region_suburb"]').val( data.suburb );
						jQuery(this).siblings('input[name="suburb"]').val( data.suburb );
					
						jQuery('#property-list-search').valid();
					});
				
					var current_suburb = jQuery('select[name="region_search"]').parent().attr('data-current-suburb');
					jQuery('select[name="region_search"] option').each(function(pm_index){
						//console.log('Check region select: ', current_suburb, jQuery(this).text());
					});
					
					jQuery('select[name="region_search"]').val(current_suburb);
					jQuery('select[name="region_search"]').trigger('change');
				}
			}
		});
	}
	
	//Property_region_search.init();

});